// src/services/workflowService.js

import api from './api';

export const getWorkflows = (campaignId) => {
    return api.get(`/workflow?campaignId=${campaignId}`);
};

export const getWorkflow = (id) => {
    return api.get(`/workflow/${id}`);
};

export const saveWorkflow = (data) => {
    return api.post('/workflow', data);
};

export const updateWorkflow = (id, data) => {
    return api.put(`/workflow/${id}`, data);
};

export const deleteWorkflow = (id) => {
    return api.delete(`/workflow/${id}`);
};

export const toggleWorkflow = (id, isEnabled) => {
    return api.post(`/workflow/${id}/toggle`, { isEnabled });
};